module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "codeforamerica.506a3ceb.png";